import React from 'react';
import moment from 'moment';
import { Content, ToggleButton, ToggleContainer } from 'v3/shared/components/Filters/FilterByWeekOrMonth/styles';
import { WeekOrMonthTabsEnum } from 'v3/shared/enums/week-or-month-tabs.enum';
import { setUpdateSellerRankFilter } from 'v3/data/store/Rank/RankSeller/actions';
import { FilterByWeekOrMonthProps } from 'v3/shared/components/Filters/FilterByWeekOrMonth/type';

export const FilterByWeekOrMonth = ({ selected, handleChangeMonthOrWeek }: FilterByWeekOrMonthProps) => {
  const handleSelect = (type) => {
    handleChangeMonthOrWeek(type);

    const today = moment();

    if (type === WeekOrMonthTabsEnum.WeekTab) {
      const start = moment(today).startOf('week');
      const end = moment(today);
      setUpdateSellerRankFilter({
        startDate: start.toISOString(),
        finalDate: end.toISOString(),
      });
    }

    if (type === WeekOrMonthTabsEnum.MonthTab) {
      const start = moment(today).startOf('month');
      const end = moment(today);
      setUpdateSellerRankFilter({
        startDate: start.toISOString(),
        finalDate: end.toISOString(),
      });
    }
  };

  return (
    <Content>
      <ToggleContainer>
        <ToggleButton
          selected={selected === WeekOrMonthTabsEnum.WeekTab}
          onClick={() => handleSelect(WeekOrMonthTabsEnum.WeekTab)}
        >
          Esta semana
        </ToggleButton>
        <ToggleButton
          selected={selected === WeekOrMonthTabsEnum.MonthTab}
          onClick={() => handleSelect(WeekOrMonthTabsEnum.MonthTab)}
        >
          Este mês
        </ToggleButton>
      </ToggleContainer>
    </Content>
  );
};
